import React from 'react';

/**
 * Hello bar. Links to checkout. Swaps to expiredText after the deadline.
 */
export default function CountdownBar({ deadline, checkoutUrl = '#request', text, expiredText }) {
  const expired = deadline ? new Date(deadline).getTime() <= Date.now() : false;

  return (
    <a className="hello" data-testid="countdown-bar" href={checkoutUrl}>
      <span>{expired ? expiredText : text}</span>
    </a>
  );
}
